import React from 'react';
import _ from 'lodash';

import PetHOC from '../PetHOC';
import FeetBack from './FeetBack';
import FeetFront from './FeetFront';
import ShellBack from './ShellBack';
import ShellFront from './ShellFront';
import Heads from './Heads';
import Eyes from './Eyes';
import Toy from '../../Goodies/Toy';

class Tortoise extends PetHOC {
	constructor(props) {
		super(props);
		this.actions = {
			idle: [
				{
					name: 'sleep',
					actions: ['isSleeping'],
					start: {
						timeout: null,
						interval: () => _.random(5000, 10000),
					},
				},
				{
					name: 'blink',
					actions: ['isBlinking'],
					start: {
						timeout: null,
						interval: () => _.random(200, 2500),
					},
					stop: {
						timeout: null,
						interval: () => 199,
					},
				},
				{
					name: 'sitting',
					actions: ['isSittingDown', 'isSittingUp'],
					start: {
						timeout: null,
						interval: () => _.random(1000, 4000),
					},
					stop: {
						timeout: null,
						interval: () => _.random(1000, 2000),
					},
				},
				{
					name: 'bobHead',
					actions: ['isBobbingHeadDown', 'isBobbingHeadUp'],
					start: {
						timeout: null,
						interval: () => _.random(700, 3000),
					},
				},
			],
			pet: [
				{
					name: 'bobHead',
					actions: ['isBobbingHeadDown', 'isBobbingHeadUp'],
					toggleBetween: true,
					start: {
						timeout: null,
						interval: () => 200,
					},
				},
				{
					name: 'sitting',
					actions: ['isSittingUp'],
					start: {
						timeout: null,
						interval: () => 200,
					},
				},
			],
		};
	}

	render() {
		return (
			<div className="pet-wrapper">
				<div
					className={this.getClassNames()}
					onMouseEnter={this.startBeingPet}
					onMouseLeave={this.stopBeingPet}>

					<img className="pet-frame" src={this.getFrameImagePathname()} alt="" />
					<div className="pet-name">{this.getName()}</div>
					<svg className="pet-shadow" viewBox="0 0 480 480">
						<ellipse cx="254" cy="366" rx="167" ry="33" />
					</svg>

					<div className="special-pet-transform-wrapper">
						<div className="pet-body-and-head">
							<svg className="pet__body pet__feet" viewBox="0 0 480 480">
								<FeetBack />
							</svg>
							<svg className="pet__body pet__in-shell" viewBox="0 0 480 480">
								<ShellBack />
							</svg>
							<svg className="pet__body pet__feet" viewBox="0 0 480 480">
								<FeetFront />
							</svg>
							<div className="pet__in-shell" viewBox="0 0 480 480">
								<svg className="pet__head" viewBox="0 0 480 480">
									<Heads getHatTargetCoords={this.getHatTargetCoords} head={this.props.head} />
									<Eyes getGlassesTargetCoords={this.getGlassesTargetCoords} />
								</svg>
							</div>
							<svg className="pet__body pet__in-shell" viewBox="0 0 480 480">
								<ShellFront />
							</svg>
							<div className="pet__in-shell" viewBox="0 0 480 480">
								<svg className="pet__head" viewBox="0 0 480 480">
									{this.shouldRenderHat()}
									{this.shouldRenderGlasses()}
								</svg>
							</div>
						</div>
					</div>

					<svg className="pet-toy" viewBox="0 0 480 480">
						<Toy toy={this.props.toy} />
					</svg>
				</div>
			</div>
		);
	}
}

export default Tortoise;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/index.js